module.exports = __webpack_public_path__ + "static/arminvanbuuren_0-f6fc5abc43b736ac67b0d1659730413f.jpg";